import ContributionGroupForm from './ContributionGroupForm';
import { Country, State } from '../../forms/address/types';
import type { Contribution } from './ContributionGroupForm';

interface PageConfig {
  contributionTypes: Array<Contribution>;
  addedContributionId: string | null;
  addedContributionAmount: string | null;
  stateFilterData: { states: State[]; countries: Country[]; };
}

window.tnew.page.initialize = ({
  contributionTypes, addedContributionId, addedContributionAmount, stateFilterData,
}: PageConfig) => {
  const form = new ContributionGroupForm(contributionTypes, stateFilterData, addedContributionId, addedContributionAmount);

  if (addedContributionId) {
    form.loadContribution(addedContributionId);
  }
};
